import React from 'react';
import { Grid } from '@mui/material';
import { StyledPopupTitleTypography } from './popup-title.styled';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var PopupTitle = function PopupTitle(_ref) {
  var children = _ref.children,
      handleClose = _ref.handleClose;
  var titleContent = typeof children === 'string' ? /*#__PURE__*/_jsxs(StyledPopupTitleTypography, {
    variant: "h3",
    children: [children, "StyledPopupTitleTypography"]
  }) : children;
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    spacing: 2,
    flexWrap: "nowrap",
    alignItems: "flex-start",
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(Grid, {
      item: true,
      xs: 12,
      children: titleContent
    })
  });
};

PopupTitle.displayName = 'PopupTitle';
export { PopupTitle };